var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mainContainerClasses},[_c('left-vessel',{attrs:{"currentActiveImageIndex":_vm.currentActiveImageIndex}}),_c('right-vessel',{on:{"currentActiveImageIndex":_vm.currentActiveImageIndexUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }